import { functions } from '../config/firebase';
import { httpsCallable } from 'firebase/functions';

/**
 * Tester les fonctions Firebase pour diagnostiquer le problème CORS
 */
export const testFunctions = async () => {
  console.log('🧪 === TEST DES FUNCTIONS FIREBASE ===');
  console.log('🔧 Functions object:', functions);
  console.log('🌐 Functions région:', functions.region);
  console.log('🏠 Functions app:', functions.app.name);
  
  try {
    // Test 1: Function Netatmo (qui marche)
    console.log('\n🧪 Test 1: Function Netatmo (référence)');
    const netatmoList = httpsCallable(functions, 'netatmoListAccounts');
    console.log('📞 Netatmo callable créée:', netatmoList);
    
    try {
      const netatmoResult = await netatmoList({});
      console.log('✅ Netatmo OK:', netatmoResult.data);
    } catch (netatmoError) {
      console.log('❌ Netatmo erreur:', netatmoError.message);
    }
    
    // Test 2: Function Automower (qui ne marche pas)
    console.log('\n🧪 Test 2: Function Automower (problématique)');
    const automowerList = httpsCallable(functions, 'automowerListAccounts');
    console.log('📞 Automower callable créée:', automowerList);
    
    try {
      const automowerResult = await automowerList({});
      console.log('✅ Automower OK:', automowerResult.data);
    } catch (automowerError) {
      console.log('❌ Automower erreur:', {
        code: automowerError.code,
        message: automowerError.message,
        details: automowerError.details
      });
    }
    
    // Test 3: Vérification region explicite
    console.log('\n🧪 Test 3: Functions avec région explicite');
    const { getFunctions } = await import('firebase/functions');
    const functionsExplicit = getFunctions(functions.app, 'us-central1');
    console.log('🌐 Functions région explicite:', functionsExplicit.region);
    
    const automowerListExplicit = httpsCallable(functionsExplicit, 'automowerListAccounts');
    try {
      const result = await automowerListExplicit({});
      console.log('✅ Automower avec région explicite OK:', result.data);
    } catch (explicitError) {
      console.log('❌ Automower région explicite erreur:', explicitError.message);
    }
    
  } catch (error) {
    console.error('💥 Erreur générale test:', error);
  }
};

/**
 * Tester si les functions sont bien déployées
 */
export const checkFunctionDeployment = async () => {
  console.log('\n🔍 === VÉRIFICATION DÉPLOIEMENT ===');
  
  const functionsToCheck = [
    'netatmoListAccounts',
    'automowerListAccounts',
    'automowerInitAuth'
  ];
  
  for (const functionName of functionsToCheck) {
    try {
      const func = httpsCallable(functions, functionName);
      console.log(`✅ ${functionName}: Callable créée correctement`);
    } catch (error) {
      console.log(`❌ ${functionName}: Erreur création callable -`, error.message);
    }
  }
};

// Export pour utilisation dans la console
window.testFunctions = testFunctions;
window.checkFunctionDeployment = checkFunctionDeployment;